import { useState } from "react";
import { Box, Container, Stack } from "@bookingcom/bui-react";
import { useNavigate } from "@tanstack/react-router";
import { AddUserHeader, AddUserForm, AddUserSuccessModal } from "../components/AddUser";

export function AddUserComponent() {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [successEmail, setSuccessEmail] = useState("");

  const handleSuccess = (email: string) => {
    setSuccessEmail(email);
    setShowSuccess(true);
  };

  const handleCloseModal = () => {
    setShowSuccess(false);
    setSuccessEmail("");
  };

  return (
    <Container>
      <Box
        mixin={{
          paddingBlockStart: 8,
          paddingBlockEnd: 8,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
        }}
      >
        <Stack gap={8}>
          <AddUserHeader onBack={() => navigate({ to: "/overview" })} />
          <AddUserForm onSuccess={handleSuccess} />
        </Stack>
      </Box>
      <AddUserSuccessModal active={showSuccess} email={successEmail} onClose={handleCloseModal} />
    </Container>
  );
}
